import { TextArea } from '@dealstack/frontend/shared/components/forms/TextArea/TextArea';
import { ButtonsRight } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts';
import {
	CancelButton,
	SaveButton,
} from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons';
import { Modal, ModalBox } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

interface Props {
	className?: string;
	onClose: () => void;
	fieldName: string;
}

const NewJoinersAndAllocationsFormTemplateInstructionModal = ({
	className,
	onClose,
	fieldName,
}: Props) => {
	const tMipCreate = useTranslationMipCreate();
	const mainForm = useFormContext();

	const instructionForm = useForm({
		defaultValues: {
			instruction: mainForm.getValues(fieldName) ?? '',
		},
	});

	const onSave = () => {
		mainForm.setValue(fieldName, instructionForm.getValues('instruction'));
		onClose();
	};

	return (
		<Modal onClose={onClose} size="sm" className={className} closeButton={false}>
			<SectionHeader
				title={tMipCreate('contracts.modals.investors.title')}
				subtitle={tMipCreate('contracts.modals.investors.subtitle')}
				size="h4b"
			/>
			<FormProvider {...instructionForm}>
				<TextArea name="instruction" rows={5} fullWidth />
			</FormProvider>
			<CounterpartiesModalButtons gap="md">
				<CancelButton onClick={onClose} />
				<SaveButton onClick={onSave} />
			</CounterpartiesModalButtons>
		</Modal>
	);
};

const CounterpartiesModalButtons = styled(ButtonsRight)`
	padding-top: 2em;
`;
const Memoized = memo(NewJoinersAndAllocationsFormTemplateInstructionModal);
const Styled = styled(Memoized)`
	${TextArea} {
		margin-top: 2.5em;
	}
	${ModalBox} {
		width: 33rem;
	}
`;

export { Styled as NewJoinersAndAllocationsFormTemplateInstructionModal };
